{#if $profile}
    <Profile profile={$profile} />
{/if}


<script>
    import Feather from './Feather.svelte'
    import { profile } from './profile'
    import App from './App.svelte'
    import Profile from './Profile.svelte'

</script>